import { Button, Collapse, Form, Layout, Space, message } from "antd";
import {
  STORE_REQUISITION_GET_SR_NO,
  STORE_REQUISITION_STORE,
} from "apiServices/API_ENDPOINTS";
import { getData, postData } from "apiServices/common";
import HandleNotification from "common/Notification";
import AppPageHeader from "common/PageHeader";
import InventoryLayOutCommon from "components/InventoryFabric/LayOut/InventoryLayOutCommon";
import { StoreRequisitionContext } from "context/StoreRequisitionContext/StoreRequisitionContextProvider";
import { useContext, useState } from "react";
import { useNavigate } from "react-router";
import { STORE_REQUISITION_CREATE_PERMISSION } from "routes/permissions";
import { hasPermission } from "utils/functions";
import moment from "moment";
import StoreRequisitionForm from "../StoreRequisitionForm";
import { buildStoreRequisitionPayload } from "../utils";

const { Content } = Layout;
const { Panel } = Collapse;

const StoreRequisitionEntry = () => {
  const { styleDetails, resetStyleDetails } = useContext(StoreRequisitionContext);
  const [isSubmit, setIsSubmit] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const goBack = () => {
    resetStyleDetails();
    navigate("/production/store-requisition");
  };

  const extra = (
    <Space>
      <Button size="small" onClick={goBack}>
        Back
      </Button>
      <Button
        htmlType="submit"
        type="primary"
        size="small"
        onClick={() => form.submit()}
        disabled={!hasPermission([STORE_REQUISITION_CREATE_PERMISSION]) || isSubmit}
        loading={isSubmit}
      >
        {hasPermission([STORE_REQUISITION_CREATE_PERMISSION])
          ? "Submit"
          : "No Permission"}
      </Button>
      <Button
        size="small"
        onClick={async () => {
          form.resetFields();
          resetStyleDetails();
          const response = await getData(STORE_REQUISITION_GET_SR_NO, false, {
            entry_date: moment().format("YYYY-MM-DD"),
          });
          if (response?.data?.code === 200 && response?.data?.data) {
            form.setFieldsValue({ requisition_no: response.data.data });
          }
        }}
      >
        Reset
      </Button>
    </Space>
  );

  const onFinish = async (values) => {
    if (!styleDetails.length) {
      message.error("Please add at least one style with items");
      return;
    }

    const hasItems = styleDetails.every(
      (style) => style.items && style.items.length > 0,
    );
    if (!hasItems) {
      message.error("Each style must have at least one item");
      return;
    }

    if (!values.buyer_id && !values.sub_contract_factory_id) {
      message.error("Please select buyer or factory");
      return;
    }

    setIsSubmit(true);
    const bodyData = buildStoreRequisitionPayload(values, styleDetails);
    const response = await postData(STORE_REQUISITION_STORE, bodyData);

    if (response) {
      HandleNotification(
        "success",
        "bottomRight",
        "Store Requisition created successfully",
        null,
      );
      resetStyleDetails();
      navigate("/production/store-requisition");
    } else {
      HandleNotification("error", "bottomRight", "Something went wrong", null);
      setIsSubmit(false);
    }
  };

  return (
    <InventoryLayOutCommon>
      <AppPageHeader title="Store Requisition - Add" extra={extra} />
      <Content className="item-details">
        <Collapse defaultActiveKey={["1"]} style={{ marginTop: 15 }}>
          <Panel header={<b>Details</b>} key="1">
            <Form layout="vertical" onFinish={onFinish} form={form}>
              <StoreRequisitionForm form={form} isCreate />
            </Form>
          </Panel>
        </Collapse>
      </Content>
    </InventoryLayOutCommon>
  );
};

export default StoreRequisitionEntry;
